'use client';

import type {
  ContentField,
  ContentLeaf,
} from '@eliadmin/core/src/api/content-fields/content-fields-types';
import { contentFieldKey } from '@eliadmin/core/src/api/content-fields/public-content-fields';
import { ContentLeafValue } from '@eliadmin/core/src/components/content-fields/content-fields';
import { hasVisibleContentLeaf } from '@eliadmin/core/src/utils/content-fields';
import { ProductContentGallery } from './product-content-gallery';

function ProductContentLeaf({ field }: { field: ContentLeaf }) {
  return field.type === 'images' ? (
    <ProductContentGallery images={field.images} name={field.name} />
  ) : (
    <ContentLeafValue field={field} />
  );
}

/** Keep the shared safe text/file renderer; only product-tab galleries have a compact preview. */
export function ProductContentField({ field }: { field: ContentField }) {
  const key = contentFieldKey('products', field.id);

  return (
    <section
      className="ea-content-fields__field flex w-full flex-col gap-4"
      data-content-field={key}
    >
      {field.items
        .filter(item => item.fields.some(hasVisibleContentLeaf))
        .map(item => (
          <div
            key={`${key}:item:${item.id}`}
            className="ea-content-fields__item flex flex-col gap-4"
          >
            {item.fields.filter(hasVisibleContentLeaf).map(leaf => (
              <div key={`${key}:item:${item.id}:field:${leaf.id}`}>
                {leaf.name.trim() !== field.name.trim() && (
                  <h3 className="mb-2 font-semibold">{leaf.name}</h3>
                )}
                <ProductContentLeaf field={leaf} />
              </div>
            ))}
          </div>
        ))}
    </section>
  );
}
